import { css  } from '@emotion/core'
import { mq } from '../../cssInJs'

export default {
  top: css(mq({
    //height: [44, null, 80],
    height: [44, null, 56],
    //background: 'black',
    background: 'transparent',
    position: 'fixed',
    width: '100%',
    zIndex: '999',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'all 0.3s'
  })),
  topScrolled: css(mq({
    background: 'white',
  })),
  logo: css(mq({
  })),
  logoImg: css(mq({
    display: 'block',
    height: ['80px', null, '100px', '120px'],
    marginTop: ['3rem', null, '3.5rem', '4rem'],
    transition:'all .2s'
  })),
  logoScrolled: css(mq({
    img : css(mq({
      height: [54, null, 65],
      marginTop:'0rem'
    }))
  })),
}